import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DestroyBase } from '../../../../../components/common/ng-destroy-base';
import { ReportDesignerPrintSettings } from '../../../models/report-designer-print-settings';
import { EventBusService } from '../../../../../services/event-bus.service';

/**
 * Print dialog
 */
@Component({
  selector: 'print-dialog',
  templateUrl: './print-dialog.component.html',
  styleUrls: ['./print-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PrintDialogComponent extends DestroyBase implements OnInit {
  /**
  * The dialog title.
  */
  public dialogTitle: string;

  /**
  * Flag indicating if the dialog should be displayed
  */
  public isDialogOpened = false;

  /**
   * Report designer print settings
   */
  public settings: ReportDesignerPrintSettings = new ReportDesignerPrintSettings();

  /**
  * Report designer print dialog options
  */
  private options: any;

  /**
   * Constructor
   * @param eventBus
   * @param translate
   */
  constructor(private eventBus: EventBusService,
    private translate: TranslateService) { super(); }

  /**
   * OnInit
   */
  public ngOnInit(): void {
    this.dialogTitle = this.translate.instant('reportDesignerPrintDialog.title');
    this.onOpenDialogEvent();
  }

  /**
   * Cancel action
   */
  public cancel(): void {
    this.isDialogOpened = false;
  }

  /**
   * Publish action
   */
  public publish(): void {
    this.isDialogOpened = false;
    if (this.options?.callback) {
      this.options.callback(this.settings);
    }
  }

  /**
   * Subscribes to print report action and displays the print dialog
   */
  private onOpenDialogEvent(): void {
    this.subscriptions.add(this.eventBus.subscribeEvent("printReport", (payload) => {
      this.settings.addWatermark = false;
      this.settings.hideBackCoverPage = true;
      this.settings.hideCoverPage = true;
      this.settings.hidePageNumbers = false;
      this.settings.imageQuality = 70;
      this.settings.includeFooter = true;
      this.settings.includeHeader = true;
      this.settings.markAsFinal = false;
      this.settings.passwordProtect = false;
      this.settings.termsAndConditions = false;
      this.settings.useCompression = false;
      this.settings.watermarkText = 'DRAFT';
      this.settings.printMethod = 0;
      this.settings.serverSidePrint = false;
      this.options = payload;
      this.isDialogOpened = true;
    }));
  }
}
